import script from "./DiyDraftCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DiyDraftCard.vue?vue&type=script&setup=true&lang=js"

import "./DiyDraftCard.vue?vue&type=style&index=0&id=3b3dc596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3dc596"]])

export default __exports__